import { BehaviorSubject } from 'rxjs';

// Interface para o estado de autenticação
interface AuthState {
    token: string | null;
    isAuthenticated: boolean;
}

// Estado inicial
const initialState: AuthState = {
    token: localStorage.getItem('gestjus_token'),
    isAuthenticated: !!localStorage.getItem('gestjus_token'),
};

// A "Store" usando BehaviorSubject (Requisito Sênior do Edital)
export const authSubject = new BehaviorSubject<AuthState>(initialState);

export const authStore = {
    // Método para logar
    login: (token: string) => {
        localStorage.setItem('gestjus_token', token);
        authSubject.next({ token, isAuthenticated: true });
    },
    // Método para deslogar
    logout: () => {
        localStorage.removeItem('gestjus_token');
        authSubject.next({ token: null, isAuthenticated: false });
    },
    // Atalho para pegar o valor atual
    getValue: () => authSubject.getValue()
};